import React, { useState } from 'react';

interface AddItemFormProps {
  onAdd: (title: string) => void;
  placeholder?: string;
}

export const AddItemForm: React.FC<AddItemFormProps> = ({ onAdd, placeholder = 'Add item...' }) => {
  const [title, setTitle] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = title.trim();
    if (!trimmed) return;
    onAdd(trimmed);
    setTitle('');
  };

  return (
    <form className="add-item-form" onSubmit={handleSubmit}>
      <input
        className="form-input"
        value={title}
        onChange={e => setTitle(e.target.value)}
        placeholder={placeholder}
      />
      <button type="submit" className="btn btn-primary btn-sm">Add</button>
    </form>
  );
};
